import {
  startOfDay,
  endOfDay,
  subDays,
  startOfWeek,
  endOfWeek,
  subWeeks,
  startOfMonth,
  endOfMonth,
  subMonths,
} from 'date-fns';

// BonBoZ: các mốc nhanh của bảng lọc ngày, xếp theo ba nhóm có tiêu đề.
//
// Thêm một mốc = thêm một dòng vào đây, không đụng tới giao diện. Mỗi mốc chỉ
// cần trả về [ngày đầu, ngày cuối]; giờ trong ngày do thanh trượt lo.

// Tuần bắt đầu THỨ HAI — đúng lịch Việt Nam, và cũng là quy ước lưới ngày của
// Chatwoot đang vẽ (`getWeeksForMonth` dùng weekStartsOn = 1).
const WEEK_OPTIONS = { weekStartsOn: 1 };

const range = (from, to) => [startOfDay(from), endOfDay(to)];

// "n ngày trước" KỂ CẢ hôm nay: 7 ngày = hôm nay + 6 ngày trước đó. Đếm kiểu
// khác thì "7 ngày qua" bỏ sót đúng ngày người ta đang trực.
const daysBack = n => () => range(subDays(new Date(), n - 1), new Date());

export const DATE_PRESET_GROUPS = [
  {
    key: 'day',
    label: 'BONBOZ.LOC_NGAY.NHOM_THEO_NGAY',
    items: [
      {
        key: 'today',
        label: 'BONBOZ.LOC_NGAY.HOM_NAY',
        range: () => range(new Date(), new Date()),
      },
      {
        key: 'yesterday',
        label: 'BONBOZ.LOC_NGAY.HOM_QUA',
        range: () => {
          const d = subDays(new Date(), 1);
          return range(d, d);
        },
      },
    ],
  },
  {
    key: 'week',
    label: 'BONBOZ.LOC_NGAY.NHOM_THEO_TUAN',
    items: [
      {
        key: 'thisWeek',
        label: 'BONBOZ.LOC_NGAY.TUAN_NAY',
        range: () =>
          range(
            startOfWeek(new Date(), WEEK_OPTIONS),
            endOfWeek(new Date(), WEEK_OPTIONS)
          ),
      },
      {
        key: 'lastWeek',
        label: 'BONBOZ.LOC_NGAY.TUAN_TRUOC',
        range: () => {
          const d = subWeeks(new Date(), 1);
          return range(
            startOfWeek(d, WEEK_OPTIONS),
            endOfWeek(d, WEEK_OPTIONS)
          );
        },
      },
      {
        key: 'last7Days',
        label: 'BONBOZ.LOC_NGAY.BAY_NGAY',
        range: daysBack(7),
      },
    ],
  },
  {
    key: 'month',
    label: 'BONBOZ.LOC_NGAY.NHOM_THEO_THANG',
    items: [
      {
        key: 'thisMonth',
        label: 'BONBOZ.LOC_NGAY.THANG_NAY',
        range: () => range(startOfMonth(new Date()), endOfMonth(new Date())),
      },
      {
        key: 'lastMonth',
        label: 'BONBOZ.LOC_NGAY.THANG_TRUOC',
        range: () => {
          const d = subMonths(new Date(), 1);
          return range(startOfMonth(d), endOfMonth(d));
        },
      },
      {
        key: 'last30Days',
        label: 'BONBOZ.LOC_NGAY.BA_MUOI_NGAY',
        range: daysBack(30),
      },
      {
        key: 'last60Days',
        label: 'BONBOZ.LOC_NGAY.SAU_MUOI_NGAY',
        range: daysBack(60),
      },
    ],
  },
];
